/* eslint-disable prefer-template, no-bitwise */
export const isLight = (color) => {
	// Variables for red, green, blue values
	let r;
	let g;
	let b;

	// Check the format of the color, HEX or RGB?
	if (color.match(/^rgb/)) {
		// If HEX --> store the red, green, blue values in separate variables
		color = color.match(
			/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/,
		);

		r = color[1];
		g = color[2];
		b = color[3];
	} else {
		// If RGB --> Convert it to HEX: http://gist.github.com/983661
		color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

		r = color >> 16;
		g = (color >> 8) & 255;
		b = color & 255;
	}

	// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
	const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

	// Using the HSP value, determine whether the color is light or dark
	if (hsp > 180) {
		return true;
	}

	return false;
};

const subtractLight = (color, amount) => {
	const cc = parseInt(color, 16, 10) - amount;
	let c = cc < 0 ? 0 : cc;
	c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
	return c;
};

export const darken = (color, amount) => {
	color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
	amount = parseInt((255 * amount) / 100, 10);
	return `#${subtractLight(color.substring(0, 2), amount)}${subtractLight(
		color.substring(2, 4),
		amount,
	)}${subtractLight(color.substring(4, 6), amount)}`;
};

const addLight = (color, amount) => {
	const cc = parseInt(color, 16) + amount;
	let c = cc > 255 ? 255 : cc;
	c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
	return c;
};

export const lighten = (color, amount) => {
	color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
	amount = parseInt((255 * amount) / 100, 10);
	return `#${addLight(color.substring(0, 2), amount)}${addLight(
		color.substring(2, 4),
		amount,
	)}${addLight(color.substring(4, 6), amount)}`;
};

export const rgb = (h, opacity = null) => {
	let r = 0;
	let g = 0;
	let b = 0;

	// 3 digits
	if (h.length === 4) {
		r = '0x' + h[1] + h[1];
		g = '0x' + h[2] + h[2];
		b = '0x' + h[3] + h[3];

		// 6 digits
	} else if (h.length === 7) {
		r = '0x' + h[1] + h[2];
		g = '0x' + h[3] + h[4];
		b = '0x' + h[5] + h[6];
	}

	if (opacity !== null) {
		return 'rgba(' + +r + ',' + +g + ',' + +b + ',' + opacity + ')';
	}
	return 'rgb(' + +r + ',' + +g + ',' + +b + ')';
};

export const rgba = (h, opacity) => {
	return rgb(h, opacity);
};

export const rem = (px, base = 16) => {
	return `${(1 / base) * px}rem`;
};
/* eslint-enable prefer-template, no-bitwise */
